<template>
  <div class="loading">
    <template v-if="loaded">更多内容请登录在艺App查看~</template>
    <template v-else-if="loading"><img src="../../../assets/img/icon/loading.gif" /></template>
  </div>
</template>
<script>
export default {
  name: 'Loading',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    loaded: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style scoped>
.loading {
  clear: both;
  padding: 80px 0 60px;
  text-align: center;
  color: #666;
  line-height: 34px;
}
.loading img {
  width: 34px;
}
</style>
